import { Children, ReactElement } from 'react';

import { Paper,Typography } from '@mui/material';

export const DISPLAYED_ROWS_COUNT = 25;
const SHOW_MORE_MESSAGE = `There were more than ${DISPLAYED_ROWS_COUNT} results, please update your search criteria to limit the result set`;

export const CustomPaperComponent = (props: React.HTMLAttributes<HTMLElement>) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const child = Children.toArray(props.children)[0] as ReactElement<any>;
    const childCount = Children.count(child?.props.children);
    if (childCount > DISPLAYED_ROWS_COUNT) {
        return (
            <Paper>
                <Typography
                    sx={{ padding: '14px 16px', opacity: '0.6' }}
                >
                    {SHOW_MORE_MESSAGE}
                </Typography>
                {props.children}
            </Paper>
        );
    }
    return (
        <Paper>
            {props.children}
        </Paper>
    );
};
